import { ProductViewPlace } from '@shared/product/models';

const PLACES_NOT_TO_SHOW_QUICKLY = ['ADD_CART', 'CS_BS', 'SMART_ASSISTANT'];

export function shouldShowQuicklyUseCase(place: ProductViewPlace): boolean {
    return !PLACES_NOT_TO_SHOW_QUICKLY.includes(place);
}
